import { render, staticRenderFns } from "./oaidFileManagement.vue?vue&type=template&id=d1adf962&scoped=true&"
import script from "./oaidFileManagement.vue?vue&type=script&lang=js&"
export * from "./oaidFileManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1adf962",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1adf962')) {
      api.createRecord('d1adf962', component.options)
    } else {
      api.reload('d1adf962', component.options)
    }
    module.hot.accept("./oaidFileManagement.vue?vue&type=template&id=d1adf962&scoped=true&", function () {
      api.rerender('d1adf962', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/packagingManagement/oaidFileManagement.vue"
export default component.exports